import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import clsx from 'clsx';

import Box from '@material-ui/core/Box';
import Dropzone from 'react-dropzone';

const useStyles = makeStyles(({ theme, colors }) => ({
    dropzone: {
        border: `2px solid ${colors.primaryColor}`,
        borderRadius: '4px',
        padding: theme.spacing(4),
        cursor: 'pointer',
        color: colors.darkGrey
    }
}));

const VideoDropzone = ({ fields, mediaType, className, onDrop, children }) => {
    const classes = useStyles();
    const handleDrop = (acceptedFiles, fileRejections) => {
        onDrop(acceptedFiles, fileRejections, fields, mediaType.key);
    };

    return (
        <Dropzone
            accept={mediaType.accept.join(', ')}
            multiple
            maxSize={50000000}
            onDrop={handleDrop}
        >
            {({ getRootProps, getInputProps }) => (
                <Box {...getRootProps()} component="div" className={clsx(classes.dropzone, className)}>
                    <input {...getInputProps()} />
                    {children}
                </Box>
            )}
        </Dropzone>
    );
};

VideoDropzone.propTypes = {
    fields: PropTypes.object.isRequired,
    mediaType: PropTypes.object.isRequired,
    className: PropTypes.string,
    onDrop: PropTypes.func,
    children: PropTypes.node
};

export default VideoDropzone;
